import React, { useEffect } from "react";
import { Box, Paper, BottomNavigation, BottomNavigationAction, Typography, ListItemButton } from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import EditIcon from "@mui/icons-material/Edit";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import StarIcon from "@mui/icons-material/Star";
import LogoutIcon from "@mui/icons-material/Logout";
// import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { logoutPresence } from "../helpers/ablyPresence";
import apilink from "../globals/Baseurls";
import user1 from "./dummyuser2.png";
import heartsBg from "./hearts4.png";
import heartsBg2 from "./hearts4.png";

export default function Profile() {
  const [tab, setTab] = React.useState(3);
  const [profile, setProfile] = React.useState({ alias: "", image: "", about: "" });
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Get user data from localStorage (synchronous)
      const userData = JSON.parse(localStorage.getItem("userSessionData"));
      const token = userData?.token;

      // Attempt to call backend logout (but don't block presence leave on failure)
      if (token) {
        try {
          await axios.post(
            `${apilink.link}/auth/logout`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log("Backend logout successful");
        } catch (apiError) {
          // Log the error but continue with local cleanup
          console.error("Backend logout failed:", apiError.response?.data?.message || apiError.message);
        }
      }

      // Leave presence channel (mark user offline in Ably)
      await logoutPresence();

      // Clear local storage
      localStorage.removeItem("userSessionData");

      // Navigate to login/home
      navigate("/");
    } catch (error) {
      // This catches any unexpected errors (e.g., malformed localStorage data)
      console.error("Logout error:", error);
      // Still try to clean up as much as possible
      await logoutPresence();
      localStorage.removeItem("userSessionData");
      navigate("/");
    }
  };

  const actionButtons = [
    { label: "Edit Photos", icon: <PhotoLibraryIcon />, link: "/upload-photos", variant: "contained" },
    { label: "Edit Profile", icon: <EditIcon />, link: "/update-profile", variant: "contained" },
    { label: "Go Premium ($1, $2 Or $3 Per Month)", icon: <StarIcon />, link: "/premium", variant: "outlined" },
    { label: "Settings", icon: <SettingsIcon />, link: "/settings", variant: "outlined" },
    { label: "Notifications", icon: <NotificationsIcon />, link: "/notifications", variant: "outlined" },
    { label: "Contact Us", icon: <HelpOutlineIcon />, link: "/support", variant: "outlined" },
    { label: "Logout", icon: <LogoutIcon />, action: () => handleLogout(), color: "error", variant: "outlined" },
  ];

  useEffect(() => {
    const getAsyncData = async () => {
      const userData = await JSON.parse(localStorage.getItem("userSessionData"));
      const name = userData.profile.display_name;
      const userbio = userData.profile.bio;
      const primaryPhotoPath = userData.photos.find(photo => photo.is_primary === 1)?.path || null;
      setProfile({ alias: name, image: primaryPhotoPath, about: userbio });
      console.log(userData)
    };
    getAsyncData();
  }, []);

  // Fetch current profile on mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userSessionData"));
        const token = userData.token;

        const response = await axios.get(`${apilink.link}/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log(response.data);

        setProfile((prev) => ({
          ...prev,
          image:
            response.data.photos?.find((p) => p.is_primary)?.path || null,
        }));
      } catch (err) {
        console.error(err.response?.data || err.message);
      }
    };

    fetchProfile();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f6f6f6", pb: 12, textAlign: "center" }}>
      {/* 🔝 Sticky Top Bar */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 20,
          backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.9)),
                    url(${heartsBg})
                    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          p: 2,
          borderBottom: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Profile Settings</Typography>
      </Box>
      {/* <Avatar sx={{ width: 96, height: 96, mx: "auto", mb: 2 }}>C</Avatar> */}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",   // stack vertically
          alignItems: "center",      // center horizontally
          justifyContent: "center",  // center vertically
          height: "170px",        // full viewport height
          textAlign: "center",
          padding: "0 16px"          // optional horizontal padding
        }}
      >
        <Box
          component="img"
          src={profile.image ? `${apilink.base_link}/storage/${profile.image}` : user1}
          alt={profile.alias}
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            objectFit: "cover",
            marginBottom: "12px"
          }}
        />

        <Typography
          variant="h6"
          style={{
            marginBottom: "8px"
          }}
        >
          {profile.alias}
        </Typography>

        <Typography
          style={{
            color: "#666", // similar to text.secondary
            marginBottom: "24px"
          }}
        >
          {profile.about}
        </Typography>
      </Box>


      <Box sx={{ px: 2, mb: 3 }}>
        {actionButtons.map((btn, idx) => (
          <Box
            key={idx}
            sx={{
              mb: 1.5,
              borderRadius: 3,
              bgcolor: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              overflow: "hidden",
              maxWidth: 420,
              mx: "auto",
            }}
          >
            {btn.link ? (
              <Link
                to={btn.link}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <ListItemButton
                  sx={{
                    py: 1.7,
                    px: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Left Side: Icon + Label */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    {btn.icon}
                    <Typography fontWeight="600" fontSize={15}>
                      {btn.label}
                    </Typography>
                  </Box>

                  {/* Right Arrow */}
                  <Typography sx={{ color: "#bbb", fontSize: 20 }}>
                    ›
                  </Typography>
                </ListItemButton>
              </Link>
            ) : (
              <ListItemButton
                onClick={btn.action}
                sx={{
                  py: 1.7,
                  px: 2,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* Left Side: Icon + Label */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {btn.icon}
                  <Typography fontWeight="600" fontSize={15}>
                    {btn.label}
                  </Typography>
                </Box>

                {/* Right Arrow */}
                <Typography sx={{ color: "#bbb", fontSize: 20 }}>
                  ›
                </Typography>
              </ListItemButton>
            )}
          </Box>
        ))}
      </Box>




      <Paper elevation={6} sx={tabStyle}>
        <BottomNavigation value={tab} onChange={(e, v) => {
          setTab(v);
          if (v === 0) navigate("/discover");
          if (v === 1) navigate("/activity");
          if (v === 2) navigate("/chats");
        }} sx={{
          height: 66,
          paddingTop: "6px",
          paddingBottom: "6px",
          borderRadius: "10px",
          backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.7)),
                    url(${heartsBg2})
                    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          "& .MuiBottomNavigationAction-root": {
            color: "#999", // inactive
          },
          "& .MuiBottomNavigationAction-root.Mui-selected": {
            color: "#010832", // active icon + label
          },
        }} showLabels>
          <BottomNavigationAction label="Explore" icon={<WhatshotIcon />} />
          <BottomNavigationAction label="Connections" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Chats" icon={<ChatIcon />} />
          <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

const tabStyle = {
  position: "fixed",
  bottom: 12,
  left: "50%",
  transform: "translateX(-50%)",
  width: "calc(100% - 24px)",
  maxWidth: 420,
  borderRadius: 8,
};
